import React from 'react';
import { Badge } from './ui/badge';
import { useProperty } from '../context/PropertyContext';

// Property Badge Component - Shows property name with brand color dot
// Can accept either a property object or a propertyId
export const PropertyBadge = ({ property, propertyId, size = 'sm', showCountry = false, variant = 'badge' }) => {
  const { properties } = useProperty();
  
  // If propertyId is provided, find the property from context
  const resolvedProperty = property || (propertyId ? properties.find(p => p.id === propertyId) : null);
  
  if (!resolvedProperty) return null;
  
  const brandColor = resolvedProperty.brandColor || resolvedProperty.brand_color || '#3F617E';
  
  // Inline variant - just dot and name without badge styling
  if (variant === 'inline') {
    return (
      <div 
        className={`inline-flex items-center gap-1.5 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}
        data-testid={`property-badge-${resolvedProperty.id}`}
      >
        <span 
          className={`${size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5'} rounded-full flex-shrink-0`}
          style={{ backgroundColor: brandColor }}
        />
        <span className="text-stone-500 truncate max-w-[120px]">{resolvedProperty.name}</span>
        {showCountry && resolvedProperty.country && (
          <span className="text-stone-400">• {resolvedProperty.country}</span>
        )}
      </div>
    );
  }
  
  // Default badge variant
  return (
    <Badge 
      variant="outline" 
      className={`
        ${size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1'}
        bg-white border-stone-200 text-stone-700 font-normal
      `}
      data-testid={`property-badge-${resolvedProperty.id}`}
    >
      <span 
        className="w-2 h-2 rounded-full mr-1.5 flex-shrink-0"
        style={{ backgroundColor: brandColor }}
      />
      <span className="truncate max-w-[120px]">{resolvedProperty.name}</span>
      {showCountry && resolvedProperty.country && (
        <span className="text-stone-400 ml-1">• {resolvedProperty.country}</span>
      )}
    </Badge>
  );
};

export default PropertyBadge;
